import React from 'react';
import zainLogo from "../../images/zain-logo2.svg";
//import zainLogo2 from "../../images/svg/zainLogo.svg";
import { AiOutlineMenu } from "react-icons/ai";
import { useStateContext } from '../../context/contextProvider';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const { themeSettings , setThemeSettings} = useStateContext();
  return (
    <div>
       <div className="navbar-bg tw-p-6 tw-z-5 tw-fixed tw-w-full tw-top-0 tw-right-0 tw-flex tw-justify-center tw-items-center tw-text-white">
        <div className="tw-w-[90%] sm:tw-w-full tw-mx-auto tw-flex tw-justify-between tw-items-center">
            <div onClick={() => setThemeSettings(true)}  className="tw-p-3 tw-cursor-pointer hover:tw-bg-white hover:tw-text-second-zain tw-rounded-md tw-duration-500">
                <span className="tw-text-2xl md:tw-text-xl"><AiOutlineMenu /></span>
            </div>
            <div>
                <span className="tw-text-2xl md:tw-text-xl sm:tw-text-[17px] xs:tw-text-xs tw-cursor-pointer">السجانة</span>
            </div>
            <div>
               <Link to="/"> <img src={zainLogo}  className="tw-w-[100px] md:tw-w-[80px] xs:tw-w-[60px] tw-cursor-pointer"/></Link>
            </div>
        </div>
         
       </div>
       <div className="tw-mt-[80px]"></div>
    </div>
  )
}

export default Navbar
